import React from 'react';
import './About.css';
import ME from '../../assets/ME.png';
import { FaAward } from 'react-icons/fa';
import { FiUsers } from 'react-icons/fi';
import { VscFolderLibrary } from 'react-icons/vsc';

const About = () => {
	return (
		<section id='about'>
			<h5>Get to know</h5>
			<h2>About me</h2>
			<div className='container about__container'>
				<div className='about__me' data-theme="primary">
					<div className='about__me-image'>
						<img src={ME} alt='me' />
					</div>
				</div>
				<div className='about__content'>
					<div className='about__cards'>
						<article className='about__card' data-theme="primary">
							<FaAward className='about__icon' data-theme="primary" />
							<h5>Experience</h5>
							<small data-theme="primary">2+ years Working as Freelancer</small>
						</article>
						<article className='about__card'>
							<FiUsers className='about__icon' />
							<h5>Clients</h5>
							<small data-theme="primary">10+ Worldwide</small>
						</article>
						<article className='about__card'>
							<VscFolderLibrary className='about__icon' />
							<h5>Projects</h5>
							<small data-theme="primary" >10+ Completed</small>
						</article>
					</div>
					<p data-theme="primary">
						Front-End Web Developer skilled in creating responsive and dynamic web applications using
						web technologies. Proficient in React js, Next js, Node js, Firebase and Tailwind css with strong
						emphasis on creating attractive user interfaces .
						I have experience in back-end development using node js, express mongo db and sql and dealing
						with the Rest api.
					</p>
					<a href='#contact' className='btn btn-primary'>
						Let's Talk
					</a>
				</div>
			</div>
		</section>
	);
};

export default About;
